module.exports = __webpack_public_path__ + "static/media/opi-main.546f67de.png";